import React, { useState } from "react";
import { Container, Reveal, useCollection } from "@/components/common";
import PageHero from "@/components/PageHero";
import { getContent } from "@/lib/api";
import { Trophy } from "@phosphor-icons/react";

export default function Awards() {
  const { data } = useCollection(() => getContent("awards"), []);
  const [filter, setFilter] = useState("All");
  const categories = ["All", ...Array.from(new Set(data.map((a) => a.category)))];
  const shown = filter === "All" ? data : data.filter((a) => a.category === filter);

  return (
    <div data-testid="awards-page">
      <PageHero label="About · Recognition" title="Awards & Recognition"
        intro="Fellowships, distinctions, leadership positions, editorial and advisory roles across a distinguished international career."
        image="https://images.pexels.com/photos/8761541/pexels-photo-8761541.jpeg" />

      <section className="bg-white py-16">
        <Container>
          <div className="mb-10 flex flex-wrap gap-2">
            {categories.map((c) => (
              <button key={c} data-testid={`awards-filter-${c}`} onClick={() => setFilter(c)}
                className={`rounded-full border px-4 py-1.5 text-xs font-medium transition-colors ${filter === c ? "border-navy bg-navy text-white" : "border-slate-300 text-navy/70 hover:border-gold"}`}>
                {c}
              </button>
            ))}
          </div>
          <div className="grid gap-6 md:grid-cols-2">
            {shown.map((a, i) => (
              <Reveal key={a.id} delay={(i % 2) * 0.06}>
                <div className="flex h-full gap-5 rounded-lg border border-slate-200 bg-white p-7 transition-transform duration-200 hover:-translate-y-1">
                  <Trophy size={26} weight="light" className="mt-1 shrink-0 text-gold-dark" />
                  <div>
                    <div className="flex items-center gap-3">
                      <span className="overline text-gold-dark">{a.category}</span>
                      {a.year && <span className="text-xs text-softgrey-400">· {a.year}</span>}
                    </div>
                    <h3 className="mt-2 font-serif text-xl leading-snug text-navy">{a.title}</h3>
                    {a.description && <p className="mt-2 text-sm text-softgrey-600">{a.description}</p>}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
